import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/pages/HomePage.vue'
import LocationsPage from '@/pages/LocationsPage.vue'
import LocationPage from '@/pages/LocationPage.vue'
import LocationFormPage from '@/pages/LocationFormPage.vue'
import SitesPage from '@/pages/SitesPage.vue'
import SiteSetupPage from '@/pages/SiteSetupPage.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: HomePage,
		meta: {
			siteSetup: false,
			addLocation: false
		},
	},
	{
		path: '/:clientId',
		name: 'Locations',
		component: LocationsPage,
		meta: {
			siteSetup: true,
			addLocation: true
		},
	},
	{
		path: '/:clientId/location/add',
		name: 'AddLocation',
		component: LocationFormPage,
		meta: {
			mode: 'add',
			siteSetup: true,
			addLocation: false
		}
	},
	{
		path: '/:clientId/location/:id',
		name: 'ViewLocation',
		component: LocationPage,
		meta: {
			siteSetup: true,
			addLocation: true
		},
	},
	{
		path: '/:clientId/location/:id/edit',
		name: 'EditLocation',
		component: LocationFormPage,
		meta: {
			mode: 'edit',
			siteSetup: true,
			addLocation: true
		}
	},
	{
		path: '/:clientId/site',
		name: 'Sites',
		component: SitesPage,
		meta: {
			siteSetup: false,
			addLocation: true,
			title: 'Site Setup'
		},
		children: [
			{
				path: ':id',
				name: 'SiteMap',
				component: SiteSetupPage,
				meta: {
					mode: 'view',
					siteSetup: false,
					addLocation: true,
					title: 'Site Setup'
				},
			},
			{
				path: ':id/edit',
				name: 'SiteMapEdit',
				component: SiteSetupPage,
				meta: {
					mode: 'edit',
					siteSetup: false,
					addLocation: true,
					title: 'Edit Site Setup'
				},
			},
		]
	},
	{
		path: '/:clientId/site/:siteId/edit',
		name: 'BranchSiteMapEdit',
		component: SiteSetupPage,
	},
	{
		path: '*',
		redirect: { name: 'Home' }
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
